import * as React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { grey } from '@mui/material/colors';

interface DeviceButtonTooltipProps extends TooltipProps {
  classicStyles?: boolean;
}

const DeviceButtonTooltip = styled(
  ({ classicStyles, className, ...props }: DeviceButtonTooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  )
)(({ theme, classicStyles }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: classicStyles ? grey[700] : '#dadde9',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: classicStyles ? grey[700] : '#f5f5f9',
    color: classicStyles ? '#f5f5f9' : grey[900],
    maxWidth: 310,
    fontSize: classicStyles ? theme.typography.pxToRem(18) : theme.typography.pxToRem(10),
    border: '1px solid #dadde9',
    textAlign: 'center',
    display: 'block',
  },
}));

export default DeviceButtonTooltip;
